export default {
  EMITIR_TITULO: 'EMITIR_TITULO',
  EMITIR_ERRATA_TITULO: 'EMITIR_ERRATA_TITULO',
  CONFERENCIA_TITULO: 'CONFERENCIA_TITULO',
  ANALISAR: 'ANALISAR',
  VALIDAR: 'VALIDAR',
  EMITIR_PORTARIA: 'EMITIR_PORTARIA',
  PUBLICACAO: 'PUBLICACAO',
  UPLOAD_TERMO_RECEBIMENTO_CONTRATO: 'UPLOAD_TERMO_RECEBIMENTO_CONTRATO',
  SOLICITAR_ARQUIVAMENTO: 'SOLICITAR_ARQUIVAMENTO',
  ELABORAR_EDITAL: 'ELABORAR_EDITAL',
  EMITIR_OFICIO: 'EMITIR_OFICIO',
  EMITIR_EXTRATO_SENTENCA: 'EMITIR_EXTRATO_SENTENCA',
  RETORNO: 'RETORNO',
  FINALIZAR: 'FINALIZAR',
  EMITIR_CERTIDAO_AREA: 'EMITIR_CERTIDAO_AREA'

}



// WEBPACK FOOTER //
// ./src/constants/acaoProcesso.js